import React, { useEffect, useState } from 'react';
import './Notification.css';

const Notification = ({ message, type, duration, onClose }) => {
    const [exiting, setExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setExiting(true);
            setTimeout(onClose, 500); // Allow time for exit animation
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div 
            className={`notification-container notification-${type} ${exiting ? 'exit' : ''}`}
            style={{ '--duration': `${duration}ms` }}
        >
            <p>{message}</p>
            <div className="notification-line"></div>
        </div>
    );
};

export default Notification;